import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import {SpeedApiSdk} from 'services/callApi'
import {entities as entitiesAction} from 'actions'

function useExchangeInfoDataProvider () {
  const dispatch = useDispatch()
  const fetchData = useCallback(async () => {
    const exchangeInfos = await SpeedApiSdk.futures.getExchangeInfo()
    dispatch(entitiesAction({exchangeInfos}))
  }, [dispatch])

  useEffect(() => {
    fetchData()
  }, [dispatch, fetchData])
}

export default useExchangeInfoDataProvider
